import React, { useRef, useState, useEffect, useCallback, useMemo } from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Modal,
  Popover,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { CheckBox } from "@mui/icons-material";
import { CustomCheckbox } from "../sharedFiles/customCheckbox/customCheckBox";
import { getItembySearch } from "../API/API";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../ReduxStore/userReducer";
import { useNavigate } from "react-router-dom";
import { GetData } from "../API/getApi";
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const Commonmodal = ({
  open,
  handleClose,
  handleChange,
  formData,
  modalValue,
  modalName,
  handleBack,
  handleForward,
  handleCloseModel,
  // handleSegmentChange,
  // handleSalesPerChange,
  handleFieldSelect,
  // opens,
  isDropdownVisible,
  handleLeadLevelClick,
  // ids,
  // anchorEl,
  // handleLeadLevelClose,
  // handleLeadLevelSelect,
  // handleDateChange,
  DueDate
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const userdata = useSelector(selectUser);
  const databaseName = userdata?.DatabaseName;
  const jwtToken = userdata?.JwtToken;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState([]);
  const [displayedData, setDisplayedData] = useState([]);
  const [itemData, setItemData] = useState([]);
  const [page, setPage] = useState(1);
  // const [EndPage, setEndPage] = useState(false);
  const itemsPerPage = 30;
  const scrollContainerRef = useRef(null);
  const [hasMoreData, setHasMoreData] = useState(true);
  // const modalRef = useRef(null);
  const [isFetching, setIsFetching] = useState(false);

  //  const handleForward = (modalName) => {   
  //     console.log("modalName :", modalName);  
  //   }
  const itemdata = formData?.ItemsChecked;
  const handleScroll = useCallback(
    debounce(() => {
      const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 40 && hasMoreData && !isFetching) {
        setIsFetching(true);
        setPage((prevPage) => prevPage + 1);
      }
    }, 200),
    [hasMoreData, isFetching]
  );

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [scrollContainerRef, handleScroll]);

  useEffect(() => {
    const fetchMoreItems = async () => {
      if (searchTerm.length > 2 && hasMoreData) {
        try {
          const response = await GetData(
            `${getItembySearch}${searchTerm}&databaseName=${databaseName}&pageNumber=${page}&pageSize=${itemsPerPage}`,
            {
              headers: {
                wg_token: jwtToken,
              },
            },
            dispatch,
            navigate
          );
          if (response.length > 0) {
            setItemData((prevData) => [...prevData, ...response]);
            setHasMoreData(response.length === itemsPerPage);
          } else {
            setHasMoreData(false);
          }
        } catch (error) {
          console.error("Data Fetch Error:", error);
          setHasMoreData(false);
        } finally {
          setIsFetching(false);
        }
      }
    };

    if (page > 1) {
      fetchMoreItems();
    }
  }, [page, searchTerm, hasMoreData]);

  const handleSearchItem = async (e) => {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);
    if (searchValue.length > 2) {
      try {
        const response = await GetData(
          `${getItembySearch}${searchValue}&databaseName=${databaseName}&pageNumber=1&pageSize=${itemsPerPage}`,
          {
            headers: {
              wg_token: jwtToken,
            },
          },
          dispatch,
          navigate
        );
        setItemData(response);
        setPage(1); // Reset page on new search
      } catch (error) {
        console.error("Search Data Fetch Error:", error);
      }
    } else {
      setItemData([]);
      setPage(1); // Reset page on new search
    }
  };

  const filtering = useCallback(() => {
    let data = [];
    if (Array.isArray(itemData) && itemData.length > 0 && modalName === "ItemsChecked") {
      data = itemData.filter(
        (item) =>
          (item.itemCode && item.itemCode.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (item.itemName && item.itemName.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    } else if (Array.isArray(modalValue) && modalName === "Segment") {
      data = modalValue;
    }
    setFilteredData(data);
    setDisplayedData(data.slice(0, page * itemsPerPage));
    setHasMoreData(data.length >= itemsPerPage);
  }, [itemData, modalValue, modalName, searchTerm, page]);
  useEffect(() => {
    filtering();
  }, [modalValue, itemData, modalName, page, filtering]);

  // const handleClickOutside = (event) => {
  //   if (modalRef.current && !modalRef.current.contains(event.target)) {
  //     handleClose();
  //     setDisplayedData([]);
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("mousedown", handleClickOutside);

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  useEffect(() => {
    if (!open) {
      setDisplayedData([]);
      // setPage(1);
    }
  }, [open]);

  useEffect(() => {
    setPage(1); // Reset page on search term change
  }, [searchTerm]);

  const keys = modalValue?.length > 0 ? Object.keys(modalValue[0]) : [];

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalBox">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {modalName}
          </Typography>

          <div className="crmFormDiv">
            {modalName === "ItemsChecked"
              || modalName === "Segment"
              || modalName === "Reference"
              || modalName === "LeadLevel"
              || modalName === "ExpectedComplationOfWork"
              || modalName === "EstimatedValue" ? (
              <div >
                {modalName === "ItemsChecked" && (
                  <>
                    <TextField
                      id="SearchTerm"
                      label="Items Search"
                      name="ItemsChecked"
                      variant="standard"
                      autoComplete="off"
                      onChange={handleSearchItem}
                    />
                    <div className="CrmInputSearch" ref={scrollContainerRef}>
                      {displayedData.length > 0 ? (
                        displayedData.map((item, index) => (
                          <div key={index}>
                            <CustomCheckbox
                              label={`${item.itemCode}-${item.itemName}`}
                              checked={
                                formData.ItemsChecked?.some(
                                  (checkedItem) => checkedItem.itemCode === item.itemCode
                                ) || false
                              }
                              onChange={handleChange}
                              name={item.itemCode}
                              value={item.itemName}
                            />
                          </div>
                        ))
                      ) : (
                        Array.isArray(itemdata) &&
                        itemdata.map((item, index) => (
                          <div key={index}>
                            <CustomCheckbox
                              label={`${item.itemCode}-${item.itemName}`}
                              checked={
                                formData.ItemsChecked?.some(
                                  (checkedItem) => checkedItem.itemCode === item.itemCode
                                ) || false
                              }
                              onChange={handleChange}
                              name={item.itemCode}
                              value={item.itemName}
                            />
                          </div>
                        ))
                      )}
                      {!hasMoreData && <div>No more items to display</div>}
                    </div>
                  </>
                )}


                {modalName === "Reference" && (
                  <div className="modaldiv">
                    <TextField
                      id="Reference"
                      label="Reference"
                      name="Reference"
                      variant="standard"
                      required
                      className="customer-textfield"
                      value={formData.Reference || ""}
                      onChange={handleChange}
                      autoComplete="off"
                    />
                  </div>
                )}
                {modalName === "LeadLevel" && (
                  // <div className="customer-creation-textfield">
                  <div className="modaldiv">
                    <TextField
                      id="LeadLevel"
                      label="Lead Level"
                      name="LeadLevel"
                      required
                      variant="standard"
                      InputProps={{
                        readOnly: true,
                      }}
                      className="customer-textfield"
                      value={formData.LeadLevel ? formData.LeadLevel : ""}
                      onClick={handleLeadLevelClick}
                      autoComplete="off"
                    />
                    
                    {isDropdownVisible &&
                      <ul className="leadLevelUl">
                        {["A", "B", "C"].map((level) => (
                          <li key={level} onClick={() => handleFieldSelect(modalName, level)}>
                            {level}
                          </li>
                        ))}
                      </ul>
                    }
                   
                  </div>
                                  
                )}
                {modalName === "ExpectedComplationOfWork" && (
                  <div className="modaldiv">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Completion Of Work"
                        name="ExpectedComplationOfWork"
                        className="customer-datefield "
                        value={formData.ExpectedComplationOfWork ? dayjs(formData.ExpectedComplationOfWork) : DueDate ?? null}
                        minDate={dayjs()}
                        // onChange={handleDateChange}
                        onChange={(newValue) =>
                          handleFieldSelect('ExpectedComplationOfWork', dayjs(newValue).format("YYYY-MM-DD"))
                        }
                        format="DD/MM/YYYY"
                      />
                    </LocalizationProvider>
                  </div>
                )}
                {modalName === "EstimatedValue" && (
                  <div className="modaldiv">
                    <TextField
                      id="EstimatedValue"
                      label="Estimated Value"
                      name="EstimatedValue"
                      required
                      variant="standard"
                      className="customer-textfield"
                      value={formData.EstimatedValue || ""}
                      onChange={handleChange}
                      autoComplete="off"
                    // onClick={handleOpen}
                    />
                  </div>
                )}

                {filteredData &&
                  modalName === "Segment" &&
                  filteredData.length > 0 &&
                  filteredData.map((item, index) => (
                    <div key={index}>
                      <CustomCheckbox
                        label={`${item.u_Segment}`}
                        checked={formData.Segment?.some(
                          (checkedItem) => checkedItem.u_Segment === item.u_Segment
                        ) || false}
                        onChange={() => {
                          const updatedSegments = formData.Segment?.some(
                            (checkedItem) => checkedItem.u_Segment === item.u_Segment)
                            ? formData.Segment.filter(
                              (checkedItem) => checkedItem.u_Segment !== item.u_Segment)
                            : [...(formData.Segment || []), item]; // Add if not checked
                          handleFieldSelect('Segment', updatedSegments);
                        }}
                        name={item.u_Segment}
                        value={item.num}
                      />
                    </div>
                  ))}
              </div>
            ) : (
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={formData[modalName] || ""}
                name="radio-buttons-group"
                onChange={modalName === "AssignExecutive" ? handleFieldSelect : handleChange}
              >
                {modalValue?.map((item, index) => (
                  modalName === "AssignExecutive" ? (
                    <FormControlLabel
                      key={index}
                      // value={item[keys[0]]}
                      value={userdata&&userdata?.slpCode}
                      name={modalName}
                      control={<Radio />}
                      label={item[keys[1]]}
                    />

                  ) : (
                    <FormControlLabel
                      key={index}
                      value={item[keys[0]]} // Use keys[0] for the value
                      name={modalName}
                      control={<Radio />}
                      label={item[keys[0]]} // Use keys[0] for the label
                    />
                  )
                ))}

              </RadioGroup>
            )}
          </div>
          {(modalName === "AssignExecutive" ||
            modalName === "customerCategory" ||
            modalName === "WalkInType" ||
            modalName === "Reference" ||
            modalName === "LeadLevel" ||
            modalName === "Segment" ||
            modalName === "CustomerProfile" ||
            modalName === "SiteType" ||
            modalName === "ItemsChecked" ||
            modalName === "EstimatedValue" ||
            modalName === "ExpectedComplationOfWork" ||
            modalName === "CurrentWorkStatus" ||
            modalName === "ReqType") && (
              <div className="modalButtons">
                <Button
                  onClick={handleBack}
                  disabled={modalName === "customerCategory"}
                >
                  Back
                </Button>
                <Button
                  onClick={() => handleForward(modalName)}
                  disabled={modalName === "ReqType"}
                >
                  Forward
                </Button>
                <Button
                onClick={handleCloseModel}
              >
                Ok
              </Button>
              </div>
            )}
        </div>

      </Modal>
    </div>
  );
};

export default Commonmodal;
// import React, { useRef, useState, useEffect, useCallback } from "react";
// import {
//   Box,
//   Button,
//   Modal,
//   Popover,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
//   FormControlLabel,
// } from "@mui/material";
// import { CustomCheckbox } from "../sharedFiles/customCheckbox/customCheckBox";
// import { getItembySearch } from "../API/API";
// import { useDispatch, useSelector } from "react-redux";
// import { selectUser } from "../ReduxStore/userReducer";
// import { useNavigate } from "react-router-dom";
// import { GetData } from "../API/getApi";
// import debounce from "lodash/debounce";
// import dayjs from "dayjs";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// const Commonmodal = ({
//   open,
//   handleClose,
//   handleChange,
//   formData,
//   modalValue,
//   modalName,
//   handleBack,
//   handleForward,
//   handleFieldChange,
//   // opens,
//   handlecheck,
//   isDropdownVisible,
//   handleLeadLevelClick,
//   ids,
//   anchorEl,
//   handleLeadLevelClose,
//   DueDate,
// }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const userdata = useSelector(selectUser);
//   const databaseName = userdata?.DatabaseName;
//   const jwtToken = userdata?.JwtToken;
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [filteredData, setFilteredData] = useState([]);
//   const [displayedData, setDisplayedData] = useState([]);
//   const [itemData, setItemData] = useState([]);
//   const [page, setPage] = useState(1);
//   const [hasMoreData, setHasMoreData] = useState(true);
//   const [isFetching, setIsFetching] = useState(false);
//   const scrollContainerRef = useRef(null);

//   const itemdata = formData?.ItemsChecked;
//   const itemsPerPage = 30;

//   const handleScroll = useCallback(
//     debounce(() => {
//       const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current;
//       if (scrollTop + clientHeight >= scrollHeight - 40 && hasMoreData && !isFetching) {
//         setIsFetching(true);
//         setPage((prevPage) => prevPage + 1);
//       }
//     }, 200),
//     [hasMoreData, isFetching]
//   );

//   useEffect(() => {
//     const scrollContainer = scrollContainerRef.current;
//     if (scrollContainer) {
//       scrollContainer.addEventListener("scroll", handleScroll);
//     }
//     return () => {
//       if (scrollContainer) {
//         scrollContainer.removeEventListener("scroll", handleScroll);
//       }
//     };
//   }, [handleScroll]);

//   useEffect(() => {
//     const fetchMoreItems = async () => {
//       if (searchTerm.length > 2 && hasMoreData) {
//         try {
//           const response = await GetData(
//             `${getItembySearch}${searchTerm}&databaseName=${databaseName}&pageNumber=${page}&pageSize=${itemsPerPage}`,
//             {
//               headers: { wg_token: jwtToken },
//             },
//             dispatch,
//             navigate
//           );
//           if (response.length > 0) {
//             setItemData((prevData) => [...prevData, ...response]);
//             setHasMoreData(response.length === itemsPerPage);
//           } else {
//             setHasMoreData(false);
//           }
//         } catch (error) {
//           console.error("Data Fetch Error:", error);
//           setHasMoreData(false);
//         } finally {
//           setIsFetching(false);
//         }
//       }
//     };

//     if (page > 1) {
//       fetchMoreItems();
//     }
//   }, [page, searchTerm, hasMoreData]);

//   const handleSearchItem = async (e) => {
//     const searchValue = e.target.value;
//     setSearchTerm(searchValue);
//     if (searchValue.length > 2) {
//       try {
//         const response = await GetData(
//           `${getItembySearch}${searchValue}&databaseName=${databaseName}&pageNumber=1&pageSize=${itemsPerPage}`,
//           {
//             headers: { wg_token: jwtToken },
//           },
//           dispatch,
//           navigate
//         );
//         setItemData(response);
//         setPage(1);
//       } catch (error) {
//         console.error("Search Data Fetch Error:", error);
//       }
//     } else {
//       setItemData([]);
//       setPage(1);
//     }
//   };

//   const filtering = useCallback(() => {
//     let data = [];
//     if (Array.isArray(itemData) && itemData.length > 0 && modalName === "ItemsChecked") {
//       data = itemData.filter(
//         (item) =>
//           (item.itemCode && item.itemCode.toLowerCase().includes(searchTerm.toLowerCase())) ||
//           (item.itemName && item.itemName.toLowerCase().includes(searchTerm.toLowerCase()))
//       );
//     } else if (Array.isArray(modalValue) && modalName === "Segment") {
//       data = modalValue;
//     }
//     setFilteredData(data);
//     setDisplayedData(data.slice(0, page * itemsPerPage));
//     setHasMoreData(data.length >= itemsPerPage);
//   }, [itemData, modalValue, modalName, searchTerm, page]);

//   useEffect(() => {
//     filtering();
//   }, [modalValue, itemData, modalName, page, filtering]);

//   useEffect(() => {
//     if (!open) {
//       setDisplayedData([]);
//     }
//   }, [open]);

//   useEffect(() => {
//     setPage(1);
//   }, [searchTerm]);

//   const keys = modalValue?.length > 0 ? Object.keys(modalValue[0]) : [];
//   console.log("isDropdownVisible", isDropdownVisible);

//   console.log("modalValue", modalValue);
//   console.log("keys", keys);
//   return (
//     <Modal open={open} onClose={handleClose}>
//       <div className="modalBox">
//         <Typography id="modal-modal-title" variant="h6" component="h2">
//           {modalName}
//         </Typography>

//         <div className="crmFormDiv">
//           {["ItemsChecked", "Segment", "Reference", "LeadLevel", "ExpectedComplationOfWork", "EstimatedValue"].includes(modalName) ? (
//             <div>
//               {modalName === "ItemsChecked" && (
//                 <>
//                   <TextField
//                     label="Items Search"
//                     variant="standard"
//                     autoComplete="off"
//                     onChange={handleSearchItem}
//                   />
//                   <div className="CrmInputSearch" 
//                   // ref={scrollContainerRef}
//                   >
//                     {(displayedData.length > 0 ? displayedData : itemdata)?.map((item, index) => (
//                       <div key={index}>
//                         <CustomCheckbox
//                           label={`${item.itemCode}-${item.itemName}`}
//                           checked={formData.ItemsChecked?.some(
//                             (checkedItem) => checkedItem.itemCode === item.itemCode
//                           )}
//                           onChange={(e) => handlecheck(e, "ItemsChecked")}
//                           name={item.itemCode}
//                           value={item.itemName}
//                         />
//                       </div>
//                     ))}
//                     {!hasMoreData && <div>No more items to display</div>}
//                   </div>
//                 </>
//               )}

//               {modalName === "Reference" && (
//                 <div className="modaldiv">
//                   <TextField
//                     label="Reference"
//                     name="Reference"
//                     variant="standard"
//                     value={formData.Reference || ""}
//                     onChange={(e) => handleChange(e.target.value, "Reference")}
//                     autoComplete="off"
//                   />
//                 </div>
//               )}

//               {modalName === "LeadLevel" && (
//                 <div className="modaldiv">
//                   <TextField
//                     label="Lead Level"
//                     name="LeadLevel"
//                     required
//                     variant="standard"
//                     InputProps={{ readOnly: true }}
//                     value={formData.LeadLevel || ""}
//                     onClick={handleLeadLevelClick}
//                     autoComplete="off"
//                   />

//                   {isDropdownVisible && (
//                     <ul className="leadLevelUl">
//                       {["A", "B", "C"].map((level) => (
//                         <li
//                           key={level}
//                           className="leadLevelUl"
//                           onClick={() => handleFieldChange(level, "LeadLevel")}
//                         >
//                           {level}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>
//               )}


//               {modalName === "ExpectedComplationOfWork" && (
//                 <div className="modaldiv">
//                   <LocalizationProvider dateAdapter={AdapterDayjs}>
//                     <DatePicker
//                       label="Completion Of Work"
//                       value={
//                         formData.ExpectedComplationOfWork
//                           ? dayjs(formData.ExpectedComplationOfWork)
//                           : DueDate ?? null
//                       }
//                       minDate={dayjs()}
//                       onChange={(newValue) =>
//                         handleFieldChange(newValue, "ExpectedComplationOfWork")
//                       }
//                       format="DD/MM/YYYY"
//                     />
//                   </LocalizationProvider>
//                 </div>
//               )}

//               {modalName === "EstimatedValue" && (
//                 <div className="modaldiv">
//                   <TextField
//                     label="Estimated Value"
//                     name="EstimatedValue"
//                     variant="standard"
//                     value={formData.EstimatedValue || ""}
//                     onChange={(e) => handleChange(e.target.value, "EstimatedValue")}
//                     autoComplete="off"
//                   />
//                 </div>
//               )}

//               {modalName === "Segment" &&
//                 filteredData.map((item, index) => (
//                   <div key={index}>
//                     <CustomCheckbox
//                       label={`${item.u_Segment}`}
//                       checked={formData.Segment?.some(
//                         (checkedItem) => checkedItem.u_Segment === item.u_Segment
//                       )}
//                       onChange={(e) => handlecheck(e, "Segment")}
//                       name={item.u_Segment}
//                       value={item.num}
//                     />
//                   </div>
//                 ))}

//             </div>
//           ) : (
//             <RadioGroup
//               value={formData[modalName] || ""}
//               onChange={modalName === "AssignExecutive" ? () => { } : handleFieldChange}
//             >
//               {modalValue?.map((item, index) =>
//                 modalName === "AssignExecutive" ? (
//                   <FormControlLabel
//                     key={index}
//                     value={item[keys[0]]}
//                     control={<Radio />}
//                     label={item[keys[1]]}
//                     onClick={(e) => handlecheck(e, "AssignExecutive")}
//                   />
//                 ) : (
//                   <FormControlLabel
//                     key={index}
//                     value={item[keys[0]]}
//                     name={modalName}
//                     control={<Radio />}
//                     label={item[keys[0]]}
//                   />
//                 )
//               )}
//             </RadioGroup>
//           )}
//         </div>

//         {(modalName === "AssignExecutive" ||
//           modalName === "customerCategory" ||
//           modalName === "WalkInType" ||
//           modalName === "Reference" ||
//           modalName === "LeadLevel" ||
//           modalName === "Segment" ||
//           modalName === "CustomerProfile" ||
//           modalName === "SiteType" ||
//           modalName === "ItemsChecked" ||
//           modalName === "EstimatedValue" ||
//           modalName === "ExpectedComplationOfWork" ||
//           modalName === "CurrentWorkStatus" ||
//           modalName === "ReqType") && (
//             <div className="modalButtons">
//               <Button onClick={handleBack} disabled={modalName === "customerCategory"}>
//                 Back
//               </Button>
//               <Button onClick={() => handleForward(modalName)} disabled={modalName === "ReqType"}>
//                 Forward
//               </Button>
//             </div>
//           )}
//       </div>
//     </Modal>
//   );
// };

// export default Commonmodal;


